import { PageTemplateView } from "@loot-os/design-system/templates/shared/PageTemplateView";

import { useTenant } from "../lib/tenant.js";
import { useBattleRoomContent } from "../templates/pages/battles/room/useBattleRoomContent.js";
import { storefrontTemplateOf } from "../templates/registry.js";

/**
 * GET /v1/battles/{battleId}: one battle through its stages (waiting, countdown, live rounds,
 * completed), laid out by the storefront template this environment chose.
 */
export function BattlePage() {
  const { config } = useTenant();
  return (
    <PageTemplateView
      template={storefrontTemplateOf(config).battle}
      content={useBattleRoomContent()}
    />
  );
}
